import { render } from "./PanelAvisosNuevo.vue?vue&type=template&id=01f51727"
import script from "./PanelAvisosNuevo.vue?vue&type=script&lang=js"
export * from "./PanelAvisosNuevo.vue?vue&type=script&lang=js"
script.render = render

export default script